var map = {
	"./1.svg": [
		73630,
		3630
	],
	"./10.svg": [
		7932,
		4932
	],
	"./11.svg": [
		23570,
		3570
	],
	"./12.svg": [
		37764,
		7764
	],
	"./13.svg": [
		23690,
		3690
	],
	"./14.svg": [
		96112,
		6112
	],
	"./15.svg": [
		7159,
		7159
	],
	"./16.svg": [
		86568,
		6568
	],
	"./17.svg": [
		37624,
		7624
	],
	"./18.svg": [
		81450,
		1450
	],
	"./19.svg": [
		40214,
		214
	],
	"./2.svg": [
		57917,
		7917
	],
	"./20.svg": [
		12896,
		2896
	],
	"./21.svg": [
		73431,
		3431
	],
	"./22.svg": [
		35309,
		5309
	],
	"./23.svg": [
		16675,
		6675
	],
	"./24.svg": [
		77551,
		7551
	],
	"./25.svg": [
		27569,
		7569
	],
	"./26.svg": [
		27852,
		7852
	],
	"./27.svg": [
		84168,
		4168
	],
	"./28.svg": [
		44813,
		4813
	],
	"./29.svg": [
		75260,
		5260
	],
	"./3.svg": [
		14842,
		4842
	],
	"./30.svg": [
		3327,
		3327
	],
	"./31.svg": [
		99622,
		9622
	],
	"./32.svg": [
		5358,
		5358
	],
	"./33.svg": [
		25099,
		5099
	],
	"./34.svg": [
		10762,
		762
	],
	"./35.svg": [
		9937,
		9937
	],
	"./36.svg": [
		58685,
		8685
	],
	"./37.svg": [
		66128,
		6128
	],
	"./38.svg": [
		88490,
		8490
	],
	"./39.svg": [
		61124,
		1124
	],
	"./4.svg": [
		21159,
		1159
	],
	"./40.svg": [
		82953,
		2953
	],
	"./41.svg": [
		78988,
		8988
	],
	"./42.svg": [
		68046,
		8046
	],
	"./43.svg": [
		53638,
		3638
	],
	"./44.svg": [
		19530,
		9530
	],
	"./45.svg": [
		8001,
		8001
	],
	"./46.svg": [
		57356,
		7356
	],
	"./47.svg": [
		68023,
		8023
	],
	"./48.svg": [
		68288,
		8288
	],
	"./49.svg": [
		67189,
		7189
	],
	"./5.svg": [
		24420,
		8790
	],
	"./50.svg": [
		3120,
		3120
	],
	"./51.svg": [
		49946,
		9946
	],
	"./52.svg": [
		42224,
		2224
	],
	"./53.svg": [
		9241,
		9241
	],
	"./54.svg": [
		67898,
		7898
	],
	"./55.svg": [
		6796,
		6796
	],
	"./56.svg": [
		13344,
		3344
	],
	"./57.svg": [
		82157,
		2157
	],
	"./58.svg": [
		12037,
		2037
	],
	"./59.svg": [
		74484,
		4484
	],
	"./6.svg": [
		67148,
		7148
	],
	"./60.svg": [
		40079,
		79
	],
	"./61.svg": [
		69000,
		9000
	],
	"./62.svg": [
		5705,
		5705
	],
	"./63.svg": [
		13005,
		3005
	],
	"./64.svg": [
		7480,
		7480
	],
	"./7.svg": [
		45253,
		5253
	],
	"./8.svg": [
		39991,
		9991
	],
	"./9.svg": [
		95489,
		5489
	],
	"./ghost.svg": [
		10805,
		805
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 13849;
module.exports = webpackAsyncContext;